var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"front-page"},[_c('Hero'),_c('Timeline'),_c('Projects'),_c('Assets'),_c('References'),_c('InTouch'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }